/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState, useRef } from 'react';
import {
    object, string, array,
} from 'prop-types';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';
import Slider from 'react-slick';
import { useUIDSeed } from 'react-uid';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import Favorite from '../../../WishlistPage/Favorite';
import ProductImageModal from '../../Partials/common/ProductImageModal';

const ProductPlantsImageUIMobile = ({
    classes,
    productName,
    name,
    path,
    additionalImages,
    partNumber,
    featureFlags,
}) => {
    /* eslint-disable react/jsx-props-no-spreading */
    const seed = useUIDSeed();
    const [activeSlideIndex, setactiveSlideIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const showProductModal = () => {
        setShowModal(true);
    };
    const hideProductModal = () => {
        setShowModal(false);
    };

    const showSatisfactionIcon = featureFlags?.['is-satisfaction-icon-enabled'] ?? false;
    const enabledZoom = featureFlags?.['is-product-zoom-enabled'] ?? false;
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        autoplay: false,
        cssEase: 'linear',
        currentSlide: 0,
        lazyLoad: true,
        arrows: false,
        beforeChange: (current, next) => setactiveSlideIndex(next),
    };

    // Create a ref to access the image element - To fix image height resolution issue
    const imageRef = useRef(null);
    const [imageHeight, setImageHeight] = useState(null);
    const handleImageLoad = () => {
        if (imageRef.current) {
            const height = imageRef.current.clientHeight;
            setImageHeight(height);
        }
    };

    return (
        <div className={classes.plantsImageContainer}>
            {activeSlideIndex === 0 && showSatisfactionIcon && <img src="/static/images/daysSatisfaction.svg" alt="30 days satisfaction" className={classes.satisfactionImage} />}
            <Slider
                {...settings}
                className={classes.plantsSliderContainer}
            >
                <div role="button" onClick={showProductModal} onKeyDown={() => { }} tabIndex={0}>
                    <img ref={imageRef} onLoad={handleImageLoad} className={`${classes.slide} ${classes.plantsSlide}`} alt={productName} src={`${path}${name}x.jpg`} />
                </div>
                {additionalImages?.map((img) => (

                    <LazyLoad key={seed(img)}>
                        <div role="button" onClick={showProductModal} onKeyDown={() => { }} tabIndex={0}>
                            <img style={{ height: imageHeight ? `${imageHeight}px` : 'auto' }} className={`${classes.slide} ${classes.plantsSlide}`} alt={productName} src={`${path}${img}x.jpg`} />
                        </div>
                    </LazyLoad>

                ))}

            </Slider>
            <Favorite partNumber={partNumber} />
            {showModal && enabledZoom && <ProductImageModal showModal={showModal} hideProductModal={hideProductModal} productName={productName} path={path} additionalImages={additionalImages} name={name} settings={settings} />}
        </div>

    );
};

ProductPlantsImageUIMobile.propTypes = {
    classes: object.isRequired,
    productName: string.isRequired,
    path: string.isRequired,
    name: string.isRequired,
    additionalImages: array.isRequired,
    brand: object.isRequired,
    partNumber: string.isRequired,
    featureFlags: object.isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default connect(
    mapStateToProps,
)(ProductPlantsImageUIMobile);
